import React from 'react';
import { useI18n } from '../lib/i18n';
export function Footer() {
  const {
    t
  } = useI18n();
  return <footer className="w-full bg-white border-t border-black/[0.06] py-12 px-6 md:px-12" data-id="element-129">
      <div className="max-w-7xl mx-auto" data-id="element-130">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8" data-id="element-131">
          <div className="flex items-center gap-3" data-id="element-132">
            <img src="https://cdn.magicpatterns.com/uploads/v8wYa1nXuUy5u1YV6say9L/favicon.png.png" alt="CLVN-LRR mark" className="w-9 h-9 object-contain" data-id="element-133" />
            <div data-id="element-134">
              <div className="font-display text-xl text-[#0A0A0F] tracking-tight leading-none" data-id="element-135">
                CLVN–LRR™
              </div>
              <div className="text-xs text-[#8A8A95] mt-1" data-id="element-136">clvn-lrr.com</div>
            </div>
          </div>

          <p className="text-xs font-mono text-[#4A4A55] tracking-wider text-center max-w-md" data-id="element-137">
            {t('footer.signature')}
          </p>

          <div className="text-right" data-id="element-138">
            <div className="inline-flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-emerald-700" data-id="element-139">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" data-id="element-140" />
              {t('blockchain.registered')} · {t('blockchain.date')}
            </div>
            <p className="text-xs text-[#8A8A95] mt-2" data-id="element-141">
              © 2025 · {t('footer.rights')}
            </p>
          </div>
        </div>
      </div>
    </footer>;
}